import styled from 'styled-components'

import media from 'utils/media'
import { ReactComponent as Logo } from 'assets/svg/phoenix_logo.svg'
import { Container } from 'components/Grid'

export const StyledFooter = styled.footer`
   padding: 60px 0;
   background: ${({ theme }) => theme.colors.accent};
   color: ${({ theme }) => theme.colors.white};
`

export const StyledContainer = styled(Container)`
   padding-left: 24px;
   padding-right: 24px;

   ${media.greaterThan('md')`
      padding-left: 16px;
      padding-right: 16px;
   `}

   & > div {  /* targeting Row component */
      ${media.greaterThan('lg')`

      `}
   }
`

export const StyledMenusWrapper = styled.div`
   margin-bottom: 60px;
   width: 100%;
   display: flex;
   justify-content: space-between;

   ${media.greaterThan('md')`
      margin-bottom: 100px;
      max-width: 476px;
   `};

   ${media.greaterThan('lg')`
      margin-bottom: 115px;
   `};

   li {
      margin-bottom: 12px;

      &.active a {
         color: ${({ theme }) => theme.colors.hotCinnamon};
      }

      &:last-of-type {
         margin-bottom: 0;
      }
   }

   a {
      display: block;
      font-size: 14px;
      line-height: 25px;
      font-weight: 300;
      letter-spacing: 0.02em;

      ${media.greaterThan('lg')`
         &:hover {
            font-weight: 400;

            svg {
               opacity: 1;
            }
         }
      `};

      &.is-active {
         color: ${({ theme }) => theme.colors.hotCinnamon};
      }
   }
`

export const StyledLinksLabel = styled.h6`
   font-weight: 400;
   font-family: 'Portrait', sans-serif;
   font-size: 14px;
   transform: translateY(-1px);
`

export const StyledMainLogo = styled.div`
   color: white;
   width: 22px;
   height: 18px;

   ${media.greaterThan('lg')`
      width: 44px;
      height: 36px;
   `};
`

export const StyledMainMenu = styled.ul`
   svg {
      display: inline-block;
      margin-left: 12px;
      opacity: 0;
      font-size: 12px;
   }
`

export const StyledSmallMenu = styled.ul`
   svg {
      display: inline-block;
      margin-left: 8px;
      opacity: 0;
      font-size: 12px;
   }
`

export const StyledInfoWrapper = styled.div`
   margin-bottom: 39px;

   ${media.greaterThan('md')`
      column-gap: 0px;
   `};

   ${media.greaterThan('lg')`
      margin-bottom: 115px;
      max-width: 454px;
      margin-left: auto;
   `};

   h1,
   h2,
   h3,
   h4 {
      font-size: 48px;
      line-height: 1;
      font-weight: 500;
      display: block;
      margin-bottom: 12px;

      span {
         color: ${({ theme }) => theme.colors.hotCinnamon};
         font-family: "Arial";
         font-weight: 700;
         display: inline-block;
         margin-right: 8px;
         ${media.greaterThan('lg')`
            margin-right: 16px;
         `}
      }

      ${media.greaterThan('xl')`
         font-size: 80px;
      `};
   }

   p {
      font-size: 18px;
      line-height: 29px;
      font-weight: 400;
      font-family: ${({ theme }) => theme.fonts.portrait};
      margin-bottom: 8px;

      &:last-of-type {
         margin-bottom: 0;
      }

      ${media.greaterThan('lg')`
         margin-bottom:24px;
      `};
   }

   a {
      font-weight: 400;
      ${media.greaterThan('lg')`
         &:hover {
            color: ${({ theme }) => theme.colors.hotCinnamon};
         }
      `};
   }
`

export const StyledCopyWrapper = styled.div`
   padding-top: 39px;
   border-top: 0.5px solid rgba(255, 255, 255, 0.3);
   transform: translateX(-1px);

   ${media.greaterThan('md')`
      display: flex;
      align-items: center;
      justify-content: space-between;
   `};

   ${media.greaterThan('md')`
      padding-top: 60px;
   `};

   & > div {
      margin-bottom: 8px;
      display: flex;
      align-items: center;

      ${media.greaterThan('md')`
         margin-bottom: 0;
      `};

      span {
         display: block;
         font-weight: 450;
         font-size: 23px;
         transform: translateY(-1px);
         line-height: 22px;
         letter-spacing: -0.01em;
         font-family: ${({ theme }) => theme.fonts.portrait};
      }
   }

   p {
      margin-bottom: 0;
      font-size: 12px;
      line-height: 19px;
      letter-spacing: 0.02em;
   }
`

export const StyledLogo = styled(Logo)`
   width: 22px;
   height: 17px;
   margin-right: 2px;
   margin-bottom: 3px;
   color: white;
`
